<div class="tierreklamationen-page">
    <div class="list-title-row">
        <button *ngIf="showReturnButton" mat-icon-button color="accent" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <h3 class="list-title">Tierreklamationen ({{ tierreklamationen?.length || 0 }})</h3>
        <span class="spacer"></span>
        <button
            *kienePermission="[9232]"
            (click)="reklamationAnlegen()"
            color="accent"
            mat-icon-button
            [disabled]="!canEditTierreklamationen"
        >
            <mat-icon>add</mat-icon>
        </button>
        <button
            *kienePermission="[9232]"
            (click)="zugriffFreigeben()"
            mat-icon-button
            color="accent"
            [disabled]="!canEditTierreklamationen"
        >
            <mat-icon>share</mat-icon>
        </button>
    </div>

    <mat-hint class="hint-text">
        <strong>Hinweis:</strong> Die hier angelegten Reklamationen dienen als Option für das Reklamieren eines Tieres
        (z.B. beim Einstallen).
    </mat-hint>

    <div class="list-wrapper" *ngIf="tierreklamationen?.length; else noTierreklamationen">
        <div class="list-header">
            <button class="sort-header" type="button" (click)="toggleSortBeschreibung()">
                Beschreibung
                <mat-icon class="sort-icon">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
            </button>
            <span></span>
        </div>
        <ng-container *ngFor="let tk of getSortedTierreklamationen()">
            <div class="list-row" (click)="editTierreklamation(tk)">
                <span class="row-value">
                    <span class="mobile-field-label">Beschreibung:</span>
                    <span class="mobile-field-value">{{ tk.reklamation }}</span>
                </span>
                <span class="row-actions">
                    <button
                        *ngIf="localStorageService.hasPermission(9232) || localStorageService.hasPermission(9234)"
                        mat-icon-button
                        [matMenuTriggerFor]="reklamMenu"
                        (click)="$event.stopPropagation()"
                        [disabled]="!canEditTierreklamationen"
                    >
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #reklamMenu="matMenu" xPosition="before" yPosition="below">
                        <button
                            *ngIf="localStorageService.hasPermission(9232)"
                            mat-menu-item
                            (click)="$event.stopPropagation(); editTierreklamation(tk)"
                            [disabled]="!canEditTierreklamationen"
                        >
                            <mat-icon>edit</mat-icon>
                            <span>bearbeiten</span>
                        </button>
                        <button
                            *ngIf="localStorageService.hasPermission(9234)"
                            mat-menu-item
                            (click)="$event.stopPropagation(); deleteTierreklamation($event, tk)"
                            [disabled]="!canEditTierreklamationen"
                        >
                            <mat-icon>delete</mat-icon>
                            <span>l&ouml;schen</span>
                        </button>
                    </mat-menu>
                </span>
            </div>
        </ng-container>
    </div>

    <ng-template #noTierreklamationen>
        <div class="empty-state">Keine Tierreklamationen gefunden.</div>
    </ng-template>
</div>
